// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1vRYi","topBottomGutter":"Layout_topBottomGutter__3SXzt"};